import { FaroButton, FaroDialog, FaroOverlay, FaroOverlayModal } from '@faro/design-system';
import React from 'react';
import styles from './UnsavedChangesOverlay.module.scss';

export interface UnsavedChangesOverlayProps {
    open: boolean;
    onKeep(): void;
    onDiscard(): void;
    onSave(): void;
    container?: HTMLElement | null;
}

/**
 * Confirm navigation when there are unsaved changes
 */
export function UnsavedChangesOverlay(props: UnsavedChangesOverlayProps): React.JSX.Element {
    const { open, onKeep, onDiscard, onSave, container } = props;

    return (
        <FaroOverlay open={open} container={container}>
            <FaroOverlayModal>
                <FaroDialog className={styles.dialog} color="primary">
                    <FaroDialog.Header>Warning</FaroDialog.Header>
                    <FaroDialog.Body>You have unsaved changes that will be lost if you continue.</FaroDialog.Body>
                    <FaroDialog.Controls className={styles.controls}>
                        <FaroButton
                            appearance="inline"
                            onClick={() => {
                                onDiscard();
                            }}
                            data-automation-id="warningDiscardButton"
                        >
                            Discard
                        </FaroButton>
                        <FaroButton
                            appearance="inline"
                            onClick={() => {
                                onKeep();
                            }}
                            data-automation-id="warningKeepEditingButton"
                        >
                            Keep editing
                        </FaroButton>
                        <FaroButton
                            color="primary"
                            onClick={() => {
                                onSave();
                            }}
                            data-automation-id="warningSaveButton"
                        >
                            Save
                        </FaroButton>
                    </FaroDialog.Controls>
                </FaroDialog>
            </FaroOverlayModal>
        </FaroOverlay>
    );
}
